import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, GridComponent,
// 数据集组件
DatasetComponent,
// 内置数据转换器组件 (filter, sort)
TransformComponent, LegendComponent, DataZoomComponent } from 'echarts/components';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
// 注册必须的组件
export default /*#__PURE__*/_defineComponent({
  __name: 'MonitorChart',
  props: {
    chartId: {
      type: String,
      required: true
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    echarts.use([TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent, LineChart, LabelLayout, UniversalTransition, CanvasRenderer, LegendComponent, DataZoomComponent]);
    const createChart = options => {
      var _document$getElements;
      const ele = (_document$getElements = document.getElementsByClassName(props.chartId)) === null || _document$getElements === void 0 ? void 0 : _document$getElements[0];
      if (!ele) {
        return false;
      }
      echarts.dispose(ele);
      const myChart = echarts.init(ele);
      myChart.resize();
      myChart.clear();
      myChart.setOption(options);
    };
    expose({
      createChart
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(__props.chartId),
        style: {
          "height": "100%"
        }
      }, null, 2);
    };
  }
});